var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 372,
    viewBox: "0 0 272 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.527 187.698C288.527 250.494 233.985 301.4 166.703 301.4C99.4219 301.4 44.8796 250.494 44.8796 187.698C44.8796 124.903 99.4219 73.9964 166.703 73.9964C233.985 73.9964 288.527 124.903 288.527 187.698Z",
    fill: "url(#paint0_linear_512_4363)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.777 48.7292H174.825V77.606H156.777V48.7292Z",
    fill: "url(#paint1_linear_512_4363)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.801,
    cy: 27.0721,
    r: 25.2671,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.606 310.424C239.372 310.424 297.551 256.286 297.551 189.503C297.551 149.125 276.283 113.369 243.602 91.4064C240.567 89.3671 236.96 88.3872 233.304 88.3872H101.907C98.2509 88.3872 94.6439 89.3671 91.6093 91.4064C58.9286 113.369 37.6604 149.125 37.6604 189.503C37.6604 256.286 95.8389 310.424 167.606 310.424Z",
    fill: "url(#paint2_linear_512_4363)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.1321,
    cy: 267.06,
    rx: 9.555,
    ry: 17.9156,
    transform: "rotate(-44.9872 75.1321 267.06)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1588 284.88C100.056 279.91 95.967 267.942 86.0265 258.148C76.086 248.354 64.0579 244.444 59.161 249.414C54.2641 254.384 58.3528 266.353 68.2933 276.147C78.2338 285.94 90.2619 289.851 95.1588 284.88ZM86.6189 278.508C89.7347 275.345 87.1331 267.73 80.8081 261.498C74.483 255.267 66.8296 252.779 63.7138 255.941C60.5979 259.104 63.1995 266.719 69.5246 272.951C75.8496 279.183 83.503 281.671 86.6189 278.508Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7031 271.264L88.2849 264.173L74.104 253.009L68.5221 260.1L82.7031 271.264ZM52.5341 280.646L54.3038 289.494L52.5341 280.646ZM33.4437 261.471C31.1183 257.063 25.6598 255.375 21.2517 257.7C16.8437 260.026 15.1553 265.484 17.4807 269.892L33.4437 261.471ZM68.5221 260.1C63.566 266.395 59.9301 268.897 57.6349 270.017C55.1881 271.21 53.9773 271.154 50.7643 271.797L54.3038 289.494C55.6028 289.235 60.3665 288.765 65.5486 286.237C70.8823 283.635 76.5296 279.105 82.7031 271.264L68.5221 260.1ZM50.7643 271.797C51.2169 271.706 50.6091 271.898 48.5079 271.246C46.6644 270.674 44.4312 269.69 42.1355 268.397C39.8512 267.11 37.7288 265.643 36.0695 264.231C35.2447 263.53 34.5998 262.897 34.1298 262.366C33.898 262.104 33.7286 261.89 33.6105 261.725C33.5524 261.644 33.5107 261.581 33.4826 261.537C33.4543 261.492 33.4429 261.47 33.4437 261.471L17.4807 269.892C19.1624 273.08 21.8587 275.837 24.376 277.979C27.0287 280.235 30.1256 282.346 33.2762 284.121C36.4153 285.889 39.8323 287.452 43.1623 288.484C46.2346 289.437 50.3234 290.291 54.3038 289.494L50.7643 271.797Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6347 271.348L88.3015 264.326L74.256 252.992L68.5892 260.015L82.6347 271.348ZM57.9484 279.743L54.8645 271.263L57.9484 279.743ZM34.6943 258.225C32.7775 253.624 27.4942 251.449 22.8937 253.365C18.2933 255.282 16.1178 260.566 18.0347 265.166L34.6943 258.225ZM18.0347 265.166C18.4925 266.265 19.0202 267.325 19.598 268.34L35.2851 259.416C35.0384 258.982 34.844 258.584 34.6943 258.225L18.0347 265.166ZM56.828 289.258C58.2221 289.065 59.635 288.732 61.0323 288.224L54.8645 271.263C54.7642 271.299 54.5974 271.347 54.3465 271.382L56.828 289.258ZM61.0323 288.224C61.4753 288.063 61.8872 287.918 62.2711 287.785L56.399 270.719C55.9188 270.885 55.4083 271.065 54.8645 271.263L61.0323 288.224ZM81.731 272.471C82.0206 272.111 82.3216 271.736 82.6347 271.348L68.5892 260.015C68.2652 260.416 67.9539 260.803 67.6545 261.176L81.731 272.471Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4182 269.291C92.5015 265.584 89.6535 261.721 86.0265 258.148C80.4016 252.606 74.1083 248.948 68.8168 247.717L71.0496 255.194C74.145 256.199 77.6428 258.38 80.8081 261.498C83.3461 263.999 85.2845 266.722 86.4947 269.291H94.4182Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2458,
    cy: 250.064,
    r: 19.1759,
    transform: "rotate(-30.6263 19.2458 250.064)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.555,
    cy: 17.9156,
    rx: 9.555,
    ry: 17.9156,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 277.708 261.144)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.258 284.88C233.361 279.91 237.45 267.942 247.39 258.148C257.331 248.354 269.359 244.444 274.256 249.414C279.153 254.384 275.064 266.353 265.124 276.147C255.183 285.94 243.155 289.851 238.258 284.88ZM246.798 278.508C243.682 275.345 246.284 267.73 252.609 261.498C258.934 255.267 266.587 252.779 269.703 255.941C272.819 259.104 270.217 266.719 263.892 272.951C257.567 279.183 249.914 281.671 246.798 278.508Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.715 271.264L245.133 264.173L259.314 253.009L264.896 260.1L250.715 271.264ZM284.451 293.656L292.524 289.625H292.524L284.451 293.656ZM274.266 320.082C269.639 321.933 264.387 319.683 262.536 315.055C260.685 310.428 262.936 305.176 267.563 303.325L274.266 320.082ZM264.896 260.1C269.806 266.338 274.415 270.069 279.09 274.01C283.703 277.899 288.912 282.39 292.524 289.625L276.377 297.687C274.583 294.093 272.033 291.666 267.458 287.809C262.944 284.005 256.933 279.163 250.715 271.264L264.896 260.1ZM292.524 289.625C294.855 294.293 295.696 299.242 294.299 304.063C292.95 308.721 289.899 311.902 287.156 313.959C282.273 317.622 275.046 319.77 274.266 320.082L267.563 303.325C268.35 303.011 269.332 302.671 270.046 302.419C270.864 302.131 271.663 301.843 272.468 301.521C274.144 300.85 275.445 300.182 276.325 299.522C277.191 298.873 277.072 298.669 276.964 299.041C276.809 299.575 277.201 299.336 276.377 297.687L292.524 289.625Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250.714 271.264L245.132 264.173L259.313 253.009L264.895 260.1L250.714 271.264ZM282.646 290.572L290.718 286.539L282.646 290.572ZM273.632 320.309C268.879 321.81 263.81 319.174 262.309 314.421C260.808 309.669 263.444 304.599 268.197 303.099L273.632 320.309ZM268.197 303.099C268.769 302.918 269.314 302.74 269.832 302.565L275.618 319.66C274.974 319.878 274.312 320.094 273.632 320.309L268.197 303.099ZM275.307 296.117C275.085 295.643 274.841 295.141 274.573 294.605L290.718 286.539C291.038 287.178 291.348 287.816 291.646 288.45L275.307 296.117ZM274.573 294.605C274.335 294.128 274.096 293.697 273.859 293.305L289.298 283.959C289.796 284.78 290.269 285.639 290.718 286.539L274.573 294.605ZM252.293 273.207C251.77 272.584 251.244 271.937 250.714 271.264L264.895 260.1C265.309 260.626 265.717 261.128 266.118 261.606L252.293 273.207Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.999 269.291C240.916 265.584 243.763 261.721 247.39 258.148C253.015 252.606 259.309 248.948 264.6 247.717L262.367 255.194C259.272 256.199 255.774 258.38 252.609 261.498C250.071 263.999 248.132 266.722 246.922 269.291H238.999Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.893,
    cy: 318.647,
    r: 19.1759,
    transform: "rotate(-30.6263 262.893 318.647)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 158.582,
    y: 261.695,
    width: 2.70719,
    height: 18.9503,
    rx: 1.3536,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 174.825,
    y: 261.695,
    width: 2.70719,
    height: 18.9503,
    rx: 1.3536,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.703,
    y: 256.281,
    width: 2.70719,
    height: 32.4863,
    rx: 1.3536,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.3628,
    y: 120.921,
    width: 209.356,
    height: 110.092,
    rx: 55.0462,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 7.21918
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.774 169.651C142.774 167.281 142.307 164.934 141.4 162.744C140.493 160.554 139.164 158.565 137.488 156.889C135.812 155.213 133.822 153.884 131.633 152.977C129.443 152.07 127.096 151.603 124.726 151.603C122.356 151.603 120.009 152.07 117.819 152.977C115.63 153.884 113.64 155.213 111.964 156.889C110.288 158.565 108.959 160.554 108.052 162.744C107.145 164.934 106.678 167.281 106.678 169.651",
    stroke: "#72B2FF",
    strokeWidth: 9.02397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233.014 169.651C233.014 167.281 232.547 164.934 231.64 162.744C230.733 160.554 229.403 158.565 227.727 156.889C226.052 155.213 224.062 153.884 221.872 152.977C219.683 152.07 217.336 151.603 214.966 151.603C212.596 151.603 210.249 152.07 208.059 152.977C205.869 153.884 203.88 155.213 202.204 156.889C200.528 158.565 199.199 160.554 198.292 162.744C197.385 164.934 196.918 167.281 196.918 169.651",
    stroke: "#72B2FF",
    strokeWidth: 9.02397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_4363",
    x1: 166.703,
    y1: 48.7292,
    x2: 166.703,
    y2: 301.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_512_4363",
    x1: 166.703,
    y1: 48.7292,
    x2: 166.703,
    y2: 301.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_512_4363",
    x1: 167.606,
    y1: 68.5818,
    x2: 167.606,
    y2: 310.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.5dc0f45ae865b789abccc8f24cf0b3c6.svg";
export { ForwardRef as ReactComponent };